import React, {useEffect, useState} from 'react';
import ic_download from 'image/icon/ic_download.svg';
import {BtnWithIconAndText} from 'components/btns';
import ic_left from 'image/ic_arrow_left.svg';
import {useHistory} from 'react-router-dom';


const BoardDetailContents = (props) => {
  const history = useHistory()

  const handleBackBtnClick = () => {
    history.goBack();
  }

  const [data, setData] = useState(props.contents);

  useEffect(()=> {
    const newText = props.contents.text.split('\n').map((line,index) => {
      return (<span key = {index}>{line}<br/></span>)
    })

    setData({
      ...props.contents,
      text: newText
    });

  }, [props])
  
  return (
    <section className={`BoardDetailContents ${props.className}`}>
      {console.log(data.text)}
      <div className="board-contents">
          <div className="btn-back" onClick = {handleBackBtnClick}>
            <img className="ic-back" src={ic_left} alt="icon back"/>
            <p>목록으로</p>
          </div>
          
          <p className="board-title">{data.title}</p>
          <p className="board-text">{data.text}</p>

          {props.lnb==='qna'
          ? <div className="wrap-files">
              {data.images
              ? data.images.map((el,index) => {                
                return <BtnWithIconAndText className="board-file down" download = {true} target = {`_blank`} to = {el.imageUrl} icon = {ic_download} text = {el.imageName} key = {index}/>
              })
              : ""}
              
            </div>
          : <div className="wrap-images">
              {data.images
                ? data.images.map(img => {
                  return <img src = {img.imageUrl} alt={img.imageName} key = {img.imageName}/>
                })
                : ""
              }
            </div>}
          
          
          <div className="wrap-caption">
            {data.user 
            ? <p className="board-user">{data.user}</p>
            : ""}
            <p className="board-date">{`${data.uploadDate}`}</p>
          </div>
        </div>


    </section>

  );
}

export default BoardDetailContents;